import React from "react";
import styles from "./AffiliatePage.module.scss";
import { Icon } from "../../atoms/Icon";
import create from "../../assets/create.svg";
import join from "../../assets/join.svg";
import earnMoney from "../../assets/earnMoney.svg";
import process from "../../assets/process.svg";

export default function WorkFlowSection({ history, isLoggedIn }) {
  return (
    <div className={styles.workflowSection}>
      <div className={'container'}><h1>How Does It Work?</h1>
      <p>
        You create your content, pair it with our products, and share. Get
        rewarded for your creativity and time. Enjoy all the brand perks
      </p>
      <div className={styles.boxRow}>
        <img src={process} className={styles.process} />
        <div className={styles.boxContainer}>
          <img src={join} />
          <div className={styles.boxContent}>
            <h3>Join</h3>
            <span>
              Create an account on Video Squirrel and complete your profile
            </span>
          </div>
        </div>
        <div className={styles.boxContainer}>
          <img src={create} />
          <div className={styles.boxContent}>
            <h3>Create</h3>
            <span>
              Upload your Video content through the VS app + pair It with our
              product
            </span>
          </div>
        </div>
        <div className={styles.boxContainer}>
          <img src={earnMoney} />
          <div className={styles.boxContent}>
            <h3>Earn Money</h3>

            <span>
              Share your content with your audience. Get paid for creating + for
              every sale
            </span>
          </div>
        </div>
      </div>
      {!isLoggedIn && (
        <button
          className={styles.pinkButton}
          onClick={() => history.push("/register")}
        >
          Join Now
        </button>
      )}
      </div>
    </div>
  );
}
